namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd2Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd2';
    }
}
